'use strict';

/*globals app*/
/*globals services*/
/*globals blockElement*/
/*globals unBlockElement*/
/*globals isEmpty*/
/*global FunctionsExecutor*/

function ProductionService() {
  this.handlingUnitRID = 0;

  this.init();
}

ProductionService.prototype = $.extend({}, {
  constructor: 'ProductionService',

  registerCallbacks: function registerCallbacks() {
    var _this = this;

    $('body').on('click', '.unhold-jcoperation', function () {
      _this.unholdJCOperation($(this).data('workplace_rid'), $(this).data('jobcard_rid'), $(this).data('jcoperation_rid'));

      return false;
    });

    $('body').on('click', '.unhold-jcoperation--confirmation', function () {
      _this.unholdJCOperationConfirmation($(this).data('workplace_rid'), $(this).data('jobcard_rid'), $(this).data('jcoperation_rid'), $(this).attr('href'));

      return false;
    });

    $('body').on('click', '.process-operation-quick--confirmation', function () {
      _this.processJCOperationQuickConfirmation($(this).attr('href'), $(this).data('operation_id'));

      return false;
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  chooseHandlingUnit: function chooseHandlingUnit(callback) {
    var _this = this;

    var parameters = {
      title: app.t('handling_unit.title'),
      content: app.t('handling_unit.choose_help'),
      asHtml: true,
      list: app.param('handling_units')
    };

    app.selectValue(parameters, function (val) {
      if (val === null) {
        return _this.chooseHandlingUnit(callback);
      }

      _this.handlingUnitRID = val;

      callback();
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  unholdJCOperation: function unholdJCOperation(workplaceRID, jobCardRID, jcOperationRID, redirectUrl) {
    var _this = this;

    blockElement(_this.$container);

    $.ajax({
      type: 'GET',
      url: app.formation('production:unhold_jcoperation'),
      async: false,
      data: { WorkplaceRID: workplaceRID, JobCardRID: jobCardRID, JCOperationRID: jcOperationRID }
    }).done(function (res) {
      unBlockElement(_this.$container);

      if (res.msg === 'SUCCESS') {
        if (isEmpty(redirectUrl)) {
          redirectUrl = app.path('production_queue', { WorkplaceRID: workplaceRID });
        }

        location.href = redirectUrl;
      } else {
        app.viewErrorMessage(res.error);
      }
    });

    return _this;
  },

  unholdJCOperationConfirmation: function unholdJCOperationConfirmation(workplaceRID, jobCardRID, jcOperationRID, url) {
    var _this = this;

    app.confirmHtml('<p>' + app.t('production.unhold_jcoperation_help') + '</p>', function (res) {
      if (res) {
        _this.unholdJCOperation(workplaceRID, jobCardRID, jcOperationRID, url);
      }
    });

    return _this;
  },

  processJCOperationQuickConfirmation: function processJCOperationQuickConfirmation(url, operationId) {
    var _this = this;

    app.confirmHtml('<p>' + app.t('production_process.submit_form_quick_confirm') + '</p>', function (res) {
      if (res) {

        var actions = [];
        var param = app.paramById('operations_settings', operationId);

        if (param && param.is_required_choose_handling_unit) {
          actions.push({ object: _this, fn: 'chooseHandlingUnit' });
        }

        var executor = new FunctionsExecutor();
        executor.execute(actions, function () {
          location.href = url + (url.endsWith('&') ? '' : '&') + 'HandlingUnitRID=' + _this.handlingUnitRID;
        });
      }
    });

    return _this;
  },

  finishProcess: function finishProcess(workplaceRID, jobCardRID, jcOperationRID, callback) {
    var _this = this;

    app.confirmHtml(app.t('production_process.finish_process_help'), function (ret) {
      if (ret) {
        services.get('user-additional-login').isUserLogined(function () {
          blockElement(_this.$container);
          app.getFormation('production_process:finish', { WorkplaceRID: workplaceRID, JobCardRID: jobCardRID, JCOperationRID: jcOperationRID }, function (res) {
            unBlockElement(_this.$container);
            if (res.msg === 'SUCCESS') {
              callback();
            } else {
              app.viewErrorMessage(res.error);
            }
          });
        });
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.$container = $('body');
    _this.registerCallbacks();

    return _this;
  }
});
